import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { isLoggedInAtom } from 'app/atoms';
import { syncLoanCalendar } from 'app/lib/calendar';
import { StorageKey, useStoredValue } from 'app/lib/storage';
import { LoanFilterKey, useAllLoans } from 'app/network/loan';
import { LoanStatus } from 'app/types/loan';
import { isMobileNative } from 'app/utils/web-helpers';

export function useSyncLoanCalendar(userId?: string) {
  const isLoggedIn = useAtomValue(isLoggedInAtom);
  const [loginAsUserId, , , impersonationLoaded] = useStoredValue<string>(StorageKey.LoginAsUserId);
  const enabled = isMobileNative && isLoggedIn && Boolean(userId) && impersonationLoaded && !loginAsUserId;
  const { data: loans, dataUpdatedAt } = useAllLoans(LoanFilterKey.Accepted, undefined, { enabled });
  const { t } = useTranslation('one-channel');

  useEffect(() => {
    if (!enabled || !userId) return;
    let active = true;
    // Re-run after a successful query refresh (including acceptance and app resume),
    // so permission/network/calendar failures can recover on the next refresh.
    void (async () => {
      for (const loan of loans ?? []) {
        if (!active) break;
        if (loan.status === LoanStatus.Accepted && loan.isUpdateFor) await syncLoanCalendar(t, userId, loan);
      }
    })();
    return () => {
      active = false;
    };
  }, [dataUpdatedAt, enabled, loans, t, userId]);
}
